/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ButtonComponent, PropertiesTableComponent, PropertiesTableRowComponent, SpinnerComponent } from "typedb-cloud-framework";
import { BehaviorSubject, Observable, map } from "rxjs";
import { AsyncPipe } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";
import { StatusIcon, StatusIndicatorComponent } from "../../../../framework/status-indicator/status-indicator.component";


@Component({
    selector: "tp-logs-control-bar",
    templateUrl: "./logs-control-bar.component.html",
    styleUrls: ["./logs-control-bar.component.scss"],
    imports: [
        AsyncPipe, ButtonComponent, MatTooltipModule, StatusIndicatorComponent
    ]
})
export class LogsControlBarComponent {
    @Input({ required: true }) title!: string;
    @Output() readonly isStreamingEnabled$ = new BehaviorSubject<boolean>(true);
    @Output() downloadLogs = new EventEmitter<void>();
    readonly toggleStreamingButtonText$: Observable<string> = this.isStreamingEnabled$.pipe(map(x => x ? "Pause output" : "Resume output"));
    readonly toggleStreamingButtonIconClass$: Observable<string> = this.isStreamingEnabled$.pipe(map(x => x ? "fa-light fa-pause" : "fa-light fa-play"));
    readonly streamingStatusText$: Observable<string> = this.isStreamingEnabled$.pipe(map(x => x ? "Live output" : "Output paused"));
    readonly streamingStatusIconClass$: Observable<StatusIcon> = this.isStreamingEnabled$.pipe(map(x => x ? "ok" : "inactive"));

    constructor() {  }

    toggleLogStream() {
        this.isStreamingEnabled$.next(!this.isStreamingEnabled$.value);
    }
}
